import React from 'react';

import './MetricItem.scss'


export const MetricItem = (props) => {

    const value = props.value;
    const description = props.description;
 
  return (    
       <div className="metric-item">
            <label className="measurement-label">{value}</label>
            <label className="description-label">{description}</label>  
            {/* <label className="measurement-label" style={{textAlign: "left"}}>N/A</label> */}
       </div>    
  );
};